<div class="flex-column gap-S pad-M" *ngIf="initialized">
	<div class="flex-align-center flex-space-between">
		<div class="font-MM fw-700">{{ 'page.data.appsLinked' | translate }}</div>
		<app-button-widget [disabled]="!isEditor" (onClick)="openDialog()" [tooltip]="'readOnly.buttonTooltip' | translate" [tooltipDisabled]="isEditor" tooltipPosition="left">
			<img *ngIf="isEditor" width="12" src="assets/icons/add.svg" class="filter-primary" alt="">
			<img *ngIf="!isEditor" width="15" src="assets/icons/lock-01.svg">
		</app-button-widget>
	</div>
	@for (app of dataApplications; track app.application.application.applicationId) {
		<div class="server-card">
			<div (click)="goToApp(app.application.application.applicationId)"
				 class="pl-s pr-m pt-s pb-s flex-space-between flex-align-center gap-S c-p">
				<div class="flex-align-center c-p">
					<div style="user-select: none" class="flex-center gap-S">
						<app-display-logo [size]="38" [logo]="app.application.application.logo"></app-display-logo>
						<div class="flex-justify-center flex-column gap-XS" style="width: 130px">
							<div class="text-overflow-ellipsis font-M fw-700">{{ app.application.application.name }}</div>
							<div *ngIf="app.application.category"
								 class="text-overflow-ellipsis font-S">{{ app.application.category.name }}
							</div>
						</div>
						<app-chips-criticality short [criticality]="app.application.application.criticality"></app-chips-criticality>
					</div>
				</div>
				<div class="flex-center gap-XS" style="height: 38px;" (click)="$event.stopPropagation();">
					<app-multi-select [disabled]="!isEditor" class="p-relative" [inputControl]="getControlForApplication(app.application.application.applicationId)" multiple [confirmButton]="false">
						<div *ngIf="app.roles.length > 0 && isEditor" class="flex-align-center p-absolute" select-trigger style="height: 38px;left: -32px;top: -19px;">
							<div class="add-data-role-button flex-center" [tooltip]="'page.data.addARole' | translate">
								<img src="assets/icons/add.svg" class="filter-primary" width="10">
							</div>
						</div>
						<div *ngIf="app.roles.length <= 0 && isEditor" class="flex-align-center" select-trigger style="height: 38px;">
							<div class="data-app-role flex-center pad-0-S gap-XS no-role-add">
								<img src="assets/icons/add.svg" width="10" class="filter-primary">
								<span>{{ 'page.data.addARole' | translate }}</span>
							</div>
						</div>
						<app-select-option [value]="DataApplicationRole.REFERENCE" [separator]="true">
							<div class="flex-align-center gap-XS">
								<img [src]="'assets/icons/data-roles/' + DataApplicationRole.REFERENCE.toLowerCase() + '.svg'" width="14" class="filter-primary">
								<span>{{ 'page.data.roles.' + DataApplicationRole.REFERENCE.toLowerCase() | translate }}</span>
							</div>
						</app-select-option>
						<app-select-option *ngFor="let role of dataRoleList" [value]="role">
							<div class="flex-align-center gap-XS">
								<img [src]="'assets/icons/data-roles/' + role.toLowerCase() + '.svg'" width="14" class="filter-primary">
								<span>{{ 'page.data.roles.' + role.toLowerCase() | translate }}</span>
							</div>
						</app-select-option>
					</app-multi-select>
					<div *ngFor="let role of app.roles | slice:0:2; index as i" [style.margin-left.px]="i === 0 ? -5 : 0" class="data-app-role flex-center pad-0-S gap-XS p-relative">
						<img [src]="'assets/icons/data-roles/' + role.toLowerCase() + '.svg'" width="14" class="filter-primary">
						<span>{{ 'page.data.roles.' + role.toLowerCase() | translate }}</span>
						<div *ngIf="isEditor" style="right: -4px; top: -4px" class="remove-role-button flex-center c-p p-absolute" (click)="removeRole(role, app.application.application.applicationId);">
							<img src="assets/icons/close.svg" width="7" class="filter-white">
						</div>
					</div>
					<div *ngIf="app.roles.length > 2" class="data-app-role flex-center pad-0-S gap-XS" [tooltipTriggerFor]="rolesTooltip">
						<span class="font-S fw-500">+{{ app.roles.length - 2 }}</span>
					</div>
					<app-tooltip #rolesTooltip>
						<div *ngFor="let role of app.roles" class="flex-align-center gap-XS">
							<img [src]="'assets/icons/data-roles/' + role.toLowerCase() + '.svg'" width="14" class="filter-white">
							<span>{{ 'page.data.roles.' + role.toLowerCase() | translate }}</span>
						</div>
					</app-tooltip>
				</div>
				<div class="flex-align-center gap-XL">
					<div>
						<app-chips-count [color]="app.application.application.usageActivated ? 'accent' : 'grey'" type="user" bold [value]="app.application.application.usageActivated ? app.usage.value || 0 : null"></app-chips-count>
					</div>
					<div style="margin-left: auto">
						<div class="disp-f justify-center a-i-c">
							<img src="assets/icons/arrow-right.svg">
						</div>
					</div>
				</div>
			</div>
		</div>
	} @empty {
		<div class="w-100 flex-center flex-column" style="gap: 30px; height: 280px;">
			<img src="assets/illustrations/empty-app.svg" width="150">
			<span class="grey">{{ 'page.data.noApps' | translate }}</span>
		</div>
	}
</div>
<div class="pad-M" *ngIf="!initialized">
	<app-dashboard-page-loader></app-dashboard-page-loader>
</div>
